/**
 * ContextMenu serves only to remove missing dependency issues while importing it
 * We do not require the full implementation of the AS3 Context Menu for our project
 */

import EventDispatcher = createjs.EventDispatcher;
import Stage = createjs.Stage;
import {URLRequest} from "../net/URLRequest";

export class ContextMenu extends createjs.EventDispatcher {
    private _builtInItems: ContextMenuBuiltInItems;
    private _clipboardItems: ContextMenuClipboardItems;
    private _clipboardMenu: boolean;
    private _customItems: Array<any> = [];
    private _isSupported: boolean;
    private _items: Array<any> = [];
    private _link: URLRequest;
    private _numItems: number = 0;

    public constructor() {
        super();
        this._builtInItems = new ContextMenuBuiltInItems();
        this._clipboardItems = new ContextMenuClipboardItems();
        this._link = new URLRequest("");
    }

    public addItemAt(item: NativeMenuItem, index: number): NativeMenuItem { return item; }
    public clone(): NativeMenu { return new NativeMenu(); }
    public containsItem(item: NativeMenuItem): Boolean { return false; }
    public display(stage: Stage, stageX: Number, stageY: Number): void { }
    public getItemAt(index: number): NativeMenuItem { return new NativeMenuItem(); }
    public getItemIndex(item: NativeMenuItem): number { return 0; }
    public hideBuiltInItems() { }
    public removeAllItems(): void { }
    public removeItemAt(index: number): NativeMenuItem { return new NativeMenuItem(); }

    get numItems(): number { return this._numItems; }
    set numItems(value: number) { this._numItems = value; }

    get link(): URLRequest { return this._link; }
    set link(value: URLRequest) { this._link = value; }

    get items(): Array<any> { return this._items; }
    set items(value: Array<any>) { this._items = value; }

    get isSupported(): boolean { return this._isSupported; }
    set isSupported(value: boolean) { this._isSupported = value; }

    get customItems(): Array<any> { return this._customItems; }
    set customItems(value: Array<any>) { this._customItems = value; }

    get clipboardMenu(): boolean { return this._clipboardMenu; }
    set clipboardMenu(value: boolean) { this._clipboardMenu = value; }

    get clipboardItems(): ContextMenuClipboardItems { return this._clipboardItems; }
    set clipboardItems(value: ContextMenuClipboardItems) { this._clipboardItems = value; }

    get builtInItems(): ContextMenuBuiltInItems { return this._builtInItems; }
    set builtInItems(value: ContextMenuBuiltInItems) { this._builtInItems = value; }
}

export class ContextMenuBuiltInItems extends Object {
    private _forwardAndBack: boolean;
    private _loop: boolean;
    private _play: boolean;
    private _print: boolean;
    private _quality: boolean;
    private _rewind: boolean;
    private _save: boolean;
    private _zoom: boolean;

    public constructor() {
        super();
    }

    public get forwardAndBack(): boolean { return this._forwardAndBack; }
    public set forwardAndBack(value: boolean) { this._forwardAndBack = value; }

    public get loop(): boolean { return this._loop; }
    public set loop(value: boolean) { this._loop = value; }

    public get play(): boolean { return this._play; }
    public set play(value: boolean) { this._play = value; }

    public get print(): boolean { return this._print; }
    public set print(value: boolean) { this._print = value; }

    public get zoom(): boolean { return this._zoom; }
    public set zoom(value: boolean) { this._zoom = value; }

    public get save(): boolean { return this._save; }
    public set save(value: boolean) { this._save = value; }

    public get rewind(): boolean { return this._rewind; }
    public set rewind(value: boolean) { this._rewind = value; }

    public get quality(): boolean { return this._quality; }
    public set quality(value: boolean) { this._quality = value; }
}

export class ContextMenuClipboardItems extends Object {
    private _clear: boolean;
    private _copy: boolean;
    private _cut: boolean;
    private _paste: boolean;
    private _selectAll: boolean;

    public constructor() {
        super();
    }

    public get selectAll(): boolean { return this._selectAll; }
    public set selectAll(value: boolean) { this._selectAll = value; }

    public get paste(): boolean { return this._paste; }
    public set paste(value: boolean) { this._paste = value; }

    public get cut(): boolean { return this._cut; }
    public set cut(value: boolean) { this._cut = value; }

    public get copy(): boolean { return this._copy; }
    public set copy(value: boolean) { this._copy = value; }

    public get clear(): boolean { return this._clear; }
    public set clear(value: boolean) { this._clear = value; }
}

export class NativeMenuItem extends EventDispatcher {
    public constructor() {
        super();
    }
}

export class NativeMenu extends EventDispatcher {
    public constructor() {
        super();
    }
}